import { useCallback } from 'react';
import { Timer } from '../../components/Timer';
import useGameContext from '../../context/GameContext';
import usePlayerContext from '../../context/PlayerContext';
import { Layout } from '../../layouts/Layout';
import { ROUTES } from '../../routes';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';
import { TIME_TO_ANSWER, useQuestionFlow } from '../../hooks/useQuestionFlow';
import { QuestionLayout } from './QuestionLayout';

export const Question = () => {
  const {
    currentQuestion,
    currentQuestionIndex,
    gameSession,
    updateGameSessionAnswers,
    setCurrentQuestionIndex,
    questionCount,
    surveyQuestionCount,
  } = useGameContext();

  const navigate = useSearchNavigate();
  const { player } = usePlayerContext();

  const completeFlow = useCallback(() => {
    if (surveyQuestionCount > 0) {
      // The survey invite is intentionally skipped in the current game flow.
      navigate(ROUTES.SurveyQuestion);
      // Previous flow: show the survey invitation before the survey questions.
      // navigate(ROUTES.SurveyInvite);
    } else {
      navigate(ROUTES.Result);
    }
  }, [navigate, surveyQuestionCount]);

  const {
    loadingNewQuestion,
    onSelectedAnswer,
    currentAnsweredQuestion,
    hasNextQuestion,
    questionStartDate,
    endFlow,
  } = useQuestionFlow({
    currentQuestion,
    currentIndex: currentQuestionIndex,
    questionCount,
    setCurrentIndex: setCurrentQuestionIndex,
    updateAnswer: (answerId, timeInSeconds) =>
      updateGameSessionAnswers(answerId, timeInSeconds ?? 0),
    onComplete: completeFlow,
    gameSession,
    trackAnswerTime: true,
  });

  const onEndGame = useCallback(() => {
    endFlow();
    completeFlow();
  }, [endFlow, completeFlow]);

  const playerName = `${player?.first_name} ${player?.last_name}`;
  const points = gameSession?.points || 0;
  const totalQuestionCount = questionCount + surveyQuestionCount;

  return (
    <Layout>
      <QuestionLayout
        mode="trivia"
        question={currentQuestion}
        currentIndex={currentQuestionIndex}
        questionCount={totalQuestionCount}
        playerName={playerName}
        points={points}
        loadingNewQuestion={loadingNewQuestion}
        hasNextQuestion={hasNextQuestion}
        selectedAnswerId={currentAnsweredQuestion?.answerId}
        correctAnswerId={currentAnsweredQuestion?.correctAnswerId}
        onSelectAnswer={onSelectedAnswer}
        onEndGame={onEndGame}
        timerSlot={
          <Timer
            startDate={questionStartDate}
            seconds={TIME_TO_ANSWER}
            paused={loadingNewQuestion}
          />
        }
      />
    </Layout>
  );
};
